import React from 'react';
import { Input, Label, Select_simple } from "./ui";
import ModalMapeo from "./ModalMapeo";

import { optionsPartido, optionsTipoEntidad } from '../datos/options';

const TabI_Identidad = ({ data, onChange }) => {//optionsPartido, optionsTipoEntidad

    const handleChange = (e) => {
        const { name, value } = e.target;
        // Mantenemos la lógica de municipio/partido que ya funcionaba
        if (name === 'municipio') {
            const select = e.target;
            const texto = select.options[select.selectedIndex]?.text || '';
            onChange({ ...data, municipio: texto, codigo_partido: value });
        } else {
            onChange({ ...data, [name]: value });
        }
    };

    const handlerOnSave = (geojson) => {
        console.log("QUE LLEGA en handlerOnSave----> ", geojson);
        onChange({ 
            ...data, 
            geom_sede: geojson.geom_sede, 
            geom_parcelas: geojson.geom_parcelas,
            parcelas_metadata: geojson.parcelas_metadata,
            sin_sede: data.sin_sede
        });
    };

    return (
        <div className="space-y-8 p-4 bg-white rounded-lg shadow-sm">

            {/* BLOQUE 0: ESTADO DEL REGISTRO */}
            <section className="flex items-center justify-between bg-blue-50 p-4 rounded-xl border border-blue-200">
                <div>
                    <Label className="text-blue-700 font-bold uppercase text-xs">Identificador RED</Label>
                    <div className="text-2xl font-black text-blue-900 tracking-widest">
                        {data.id_red || "NUEVO-REGISTRO"}
                    </div>
                </div>
                <div className="text-right">
                    <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase ${data.id_red ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'}`}>
                        {data.id_red ? 'Entidad Registrada' : 'Pendiente de Alta'}
                    </span>
                </div>
            </section>
            
            {/* --- SECCIÓN 1: DATOS GENERALES --- */}
            <section className="space-y-4">
                <h3 className="text-lg font-bold text-blue-700 border-b pb-1">Datos Generales</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="md:col-span-2">
                        <Label>Nombre completo de la entidad</Label>
                        <Input name="nombre_completo" value={data.nombre_completo || ''} onChange={handleChange} />
                    </div>
                    <div>
                        <Label>Denominación de fantasía</Label>
                        <Input name="nombre_fantasia" value={data.nombre_fantasia || ''} onChange={handleChange} />
                    </div>
                    <div>
                        <Label>Tipo de entidad</Label>
                        <Select_simple
                            name="tipo_entidad"
                            value={data.tipo_entidad || ''}
                            onChange={handleChange}
                            placeholder="Seleccionar..."
                            options={optionsTipoEntidad}
                        />
                    </div>
                    <div>
                        <Label>Fecha de fundación</Label>
                        <Input type="date" name="fecha_fundacion" value={data.fecha_fundacion || ''} onChange={handleChange} />
                    </div>
                </div>
            </section>

            {/* --- SECCIÓN 2: DOMICILIOS Y MAPEO --- */}
            <section className="space-y-4 bg-slate-50 p-4 rounded-xl border border-slate-200">
                <div className="flex justify-between items-center">
                    <h3 className="text-lg font-bold text-blue-700">Domicilios</h3>
                    <div className="flex items-center gap-4">
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                checked={data.sin_sede || false}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    onChange({
                                        ...data,
                                        sin_sede: checked,
                                        geom_sede: checked ? null : data.geom_sede
                                    });
                                }}
                                className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                            />
                            <span className="text-sm text-gray-700 font-normal">No tiene sede</span>
                        </label>
                        <ModalMapeo 
                            partido={data.codigo_partido} 
                            initialData={data.geom_sede}
                            initialDataParcelas={data.geom_parcelas}
                            initialParcelasMetadata={data.parcelas_metadata}
                            sinSede={data.sin_sede || false}
                            onSave={handlerOnSave}
                        />
                    </div>
                </div>
                {data.sin_sede && (
                    <p className="text-sm text-amber-600 bg-amber-50 p-2 rounded">
                        Esta entidad no posee sede física. Si desea agregar una ubicación, desmarque la opción "No tiene sede".
                    </p>
                )}
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
					<div>
                        <Label>Partido <span className="text-red-500">*</span></Label>
                        <Select_simple 
                            name="municipio" 
                            value={data.codigo_partido || ''} 
                            onChange={handleChange} 
                            options={optionsPartido}
                            placeholder="Seleccionar..."
                            disabled={!!data.id_red}
                        />
                        {!data.codigo_partido && !data.id_red && (
                            <span className="text-sm text-amber-600 flex items-center gap-1 mt-1">
                                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                </svg>
                                Este campo es obligatorio
                            </span>
                        )}
                        {data.id_red && (
                            <span className="text-sm text-gray-500 mt-1">
                                El partido no puede modificarse en una entidad existente
                            </span>
                        )}
                    </div>
                    <div>
                        <Label>Localidad</Label>
                        <Input name="localidad" value={data.localidad || ''} onChange={handleChange} />
                    </div>
                    <div>
                        <Label>Domicilio Legal</Label>
                        <Input name="domicilio_legal" value={data.domicilio_legal || ''} onChange={handleChange} />
                    </div>
                    <div>
                        <Label>Domicilio de Actividades (si es distinto)</Label>
                        <Input name="domicilio_deportivo" value={data.domicilio_deportivo || ''} onChange={handleChange} />
                    </div>
                    
                </div>
            </section>

            {/* --- SECCIÓN 3: CONTACTO Y WEB --- */}
            <section className="space-y-4">
                <h3 className="text-lg font-bold text-blue-700 border-b pb-1">Contacto y Redes</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        <Label>Teléfono de contacto</Label>
                        <Input name="telefono" value={data.telefono || ''} onChange={handleChange} />
                    </div>
                    <div className="md:col-span-2">
                        <Label>Correo electrónico institucional</Label>
                        <Input type="email" name="email" value={data.email || ''} onChange={handleChange} />
                    </div>
                    <div>
                        <Label>Página Web</Label>
                        <Input name="web" placeholder="www.ejemplo.com" value={data.web || ''} onChange={handleChange} />
                    </div>
                    <div className="md:col-span-2">
                        <Label>Redes Sociales</Label>
                        <Input name="redes_sociales" placeholder="Instagram, Facebook, etc." value={data.redes_sociales || ''} onChange={handleChange} />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TabI_Identidad;